import React from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
export type Props = React.PropsWithChildren<{}>;

const TableBody: React.FC = ({ children }) => (
  <tbody className="origami-TableBody">{children}</tbody>
);

export default TableBody;
